import { request } from '../request'

// 获得各tab未审核总数及各tab页初始条件
export function getTotalCount(surveyId, params) {
  return request({
    url: '/answer/qualityControl/getTotalCount/' + surveyId,
    method: 'get',
    params
  })
}

// 抽样数据---分页查询
export function getSamplingData(params) {
  return request({
    url: '/answer/qualityControl/page',
    method: 'get',
    params
  })
}

// 重新抽取
export function reSelect(data) {
  return request({
    url: '/answer/qualityControl/reselect',
    method: 'post',
    data
  })
}

// 一键质控
export function auditBatch(data) {
  return request({
    url: '/answer/qualityControl/auditBatch',
    method: 'post',
    data
  })
}

// 单项质控
export function auditOne(data) {
  return request({
    url: '/answer/qualityControl/auditOne',
    method: 'post',
    data
  })
}

// 驳回 20200830
export function rejectQuestion(data) {
  return request({
    url: '/answer/qualityControl/reject',
    method: 'post',
    data
  })
}
// 保存答卷的 答案 20201105
export function saveAnswer(data) {
  return request({
    url: '/answer/answer/editAnswer',
    method: 'post',
    data
  })
}

// 重新质控 20210323
export function reaudit(data) {
  return request({
    url: '/answer/qualityControl/reaudit',
    method: 'post',
    data
  })
}

// 审核（查看详情）
export function queryQCDetailById(params) {
  return request({
    url: '/answer/qualityControl/detail/' + params.answerId,
    method: 'get',
    params: {
      onlyMainQuestions: params.onlyMainQuestions,
      preAudit: params.preAudit
    }
  })
}

// 获取重点问题
export function getMainQuestionsById(surveyId) {
  return request({
    url: '/answer/qualityControl/getMainQuestions/' + surveyId,
    method: 'get'
  })
}

// 设置重点问题
export function resetMainQuestions(data) {
  return request({
    url: '/answer/qualityControl/resetMainQuestions',
    method: 'post',
    data
  })
}

// 获取质控报告
export function getQcReport(surveyId) {
  return request({
    url: '/answer/qualityControl/getQcReport/' + surveyId,
    method: 'get'
  })
}

/**
 * 查询陷阱题问题数据
 * @param{{
 *   surveyId:*
 *   qcMethodType:number
 * }} params
 */
export function getCtrlList(params) {
  return request({
    url: '/wenjuanLogic/qcLogic/getTrapsInfo',
    params,
    method: 'GET'
  })
}

//智能门店审核 - 获取下拉框联级
export function queryDownConfig(params) {
  return request({
    url: '/admin/voiceVR/queryDownConfig',
    params,
    method: 'GET'
  })
}

// 智能门店审核 - 插入审核结果关联数据
export function addScore(data) {
  return request({
    url: '/admin/voiceVR/addScore',
    method: 'post',
    data
  })
}

// 智能门店审核 - 批量插入智能门店答题成绩
export function addScoreList(data) {
  return request({
    url: '/admin/voiceVR/addScoreList',
    method: 'post',
    data
  })
}